import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import { api } from "../lib/api";

export function AdminSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const box = useRef(null);

  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get(`/admin/search?q=${encodeURIComponent(q.trim())}`).then(r => { setRes(r.data.results); setOpen(true); }).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  function go(email) { setOpen(false); setQ(""); nav(`/admin/clients/${encodeURIComponent(email)}`); }

  return (
    <div ref={box} className="relative px-4 pt-4" data-testid="admin-search">
      <div className="flex items-center gap-2 bg-white border border-[#E8DCC8] px-3 py-2">
        <Search size={14} className="text-[#A3876A] shrink-0"/>
        <input data-testid="admin-search-input" value={q} onChange={e => setQ(e.target.value)} onFocus={() => res.length && setOpen(true)}
          onKeyDown={e => { if (e.key === "Enter" && res[0]) go(res[0].email); if (e.key === "Escape") setOpen(false); }}
          placeholder="Chercher une cliente…" className="flex-1 text-sm bg-transparent outline-none placeholder:text-[#B5A999]"/>
        {q && <button onClick={() => { setQ(""); setRes([]); }} className="text-[#7C7064]" aria-label="Effacer"><X size={13}/></button>}
      </div>
      {open && q.trim().length >= 2 && (
        <div data-testid="admin-search-results" className="absolute left-4 right-4 z-50 mt-1 bg-white border border-[#E8DCC8] shadow-lg max-h-80 overflow-auto">
          {res.length === 0 && <p className="p-3 text-xs text-[#7C7064] italic">Aucune cliente trouvée.</p>}
          {res.map(r => (
            <button key={r.email} data-testid={`admin-search-result-${r.email}`} onClick={() => go(r.email)}
              className="w-full text-left px-3 py-2 hover:bg-[#F5F0E6] border-b border-[#F0E8DA] last:border-0">
              <p className="text-sm text-[#2C2621]">{r.name || r.email}</p>
              <p className="text-[11px] text-[#7C7064] truncate">{r.name ? `${r.email} · ` : ""}{r.kinds.join(" · ")}{r.extra ? ` · ${r.extra}` : ""}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
